import React, {Component} from 'react';
import StringUtil from "../../utils/StringUtil";
import {TextInput, Wizard} from "../../components";
import RemotingService from "../../services/remoting-service/RemotingService";
import ValidationUtil from "../../components/form/validator/ValidationUtil";
import SignatureInput from "../../components/signature-input/SignatureInput";
import FormField from "../../components/form/FormField";
import PatientUtil from "../../utils/PatientUtil";
import DateUtil from "../../utils/DateUtil";
import FormLanguages from "./enum/FormLanguages";
import moment from "moment/moment";
import SignatureDisplay from '../../components/signature-input/SignatureDisplay';
import {isMinor} from '../patient/Patient';
import PsychologyFormTextEnum from './enum/PsychologyFormTextEnum';
import ClinicLogo from "../../layout/ClinicLogo";

class PsychologyConsentForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            patientDate: new Date()
        }

        this.formFields = [];
    }

    componentDidMount() {
        RemotingService.getRemoteCall('api/appointment/first-provider/UAE/' + this.props.patient.id, {},
            (firstProvider) => {
                if (firstProvider) {
                    this.setState({ providerName: firstProvider.name, providerSignature: firstProvider.signature });
                }
            });
    }

    onSubmit = () => {
        if (!ValidationUtil.checkWithNotification(this.formFields)) {
            return;
        }

        if (this.props.form !== null && this.props.form !== undefined) {
            this.props.close();
        } else {
            const patient = this.props.patient;
            const patientFullName = PatientUtil.getPatientName(patient.firstName, patient.middleName, patient.lastName);
            const patientMrn = StringUtil.mrn(patient.mrn);
            const patientDOB = patient.birthday;

            const {
                patientDate, guardianName, guardianRelationship,
                patientSignature, witnessName, witnessSignature, providerName, providerSignature
            } = this.state;

            RemotingService.postRemoteCall(`api/patient/${this.props.patient.id}/psychology-consent-form`,
                {
                    patientDate,
                    guardianName,
                    guardianRelationship,
                    patientSignature,
                    witnessName,
                    witnessSignature,
                    patientFullName,
                    patientMrn,
                    patientDOB,
                    providerName,
                    providerSignature
                },
                (result) => {
                    this.props.afterSave(result);
                    this.props.close();
                });
        }
    }

    onSaveWitnessSignature = (signature) => {
        this.setState({ witnessSignature: signature })
    }

    onSavePatientSignature = (signature) => {
        this.setState({ patientSignature: signature })
    }

    getLocalizedText(key) {
        const selectedLanguage = this.props.selectedLanguage || FormLanguages.ENGLISH.name;
        const textEnum = PsychologyFormTextEnum;
        return textEnum[key] ? textEnum[key][selectedLanguage.name] : '';
    }

    render() {
        if (!this.props.show)
            return null;

        let { patient, form } = this.props;
        let readOnly = form !== null && form !== undefined;
        let mrnNo = StringUtil.mrn(patient.mrn);
        let patientName = PatientUtil.getPatientName(patient.firstName, patient.middleName, patient.lastName);
        this.formFields = [];

        const selectedLanguage = this.props.selectedLanguage || FormLanguages.ENGLISH.name;
        const enumLabel = selectedLanguage === FormLanguages.ARABIC ? "nameInArabic" : "name";
        const isPatientMinor = isMinor(patient.birthday, 'KUWAIT');

        return (
            <Wizard
                show={this.props.show}
                close={this.props.close}
                title={this.getLocalizedText('Form_Header')}
                onSubmit={this.onSubmit}
                isReadOnly={readOnly}
            >
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{ maxWidth: '950px' }}>
                        <div style={{
                            marginTop: '15px', marginBottom: '15px', width: '100%', display: 'flex',
                            flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center'
                        }}>
                            <ClinicLogo/>
                            <div>
                                <h2>{this.getLocalizedText('Form_Title')}</h2>
                            </div>
                        </div>

                        <hr style={{
                            borderTop: "2px solid #000000",
                            marginTop: "-10px",
                            boxShadow: "0px 2px 2px #797979"
                        }} />

                        <div style={{ border: "1px solid #000000" }}>
                            <div style={{ margin: "15px 15px" }}>
                                <h5>{this.getLocalizedText('Patient_Information')}</h5>
                                <div className={"row"} style={{ marginTop: "10px", marginLeft: "0px" }}>
                                    <div className="col-md-5">
                                        <b>{this.getLocalizedText('Name')}</b> {patientName}
                                    </div>
                                    <div className="col-md-4">
                                        <b>{this.getLocalizedText('MRN')}</b> {mrnNo}
                                    </div>
                                    <div className="col-md-3">
                                        <b>{this.getLocalizedText('DOB')}</b> {DateUtil.formatDate(patient.birthday)}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{ border: "1px solid #000000", margin: "10px 0px" }}>
                            <div style={{ margin: "15px 15px" }}>
                                {this.getLocalizedText('Treatment_Consideration')}
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{ maxWidth: '950px' }}>
                        <div style={{ border: "1px solid #000000", margin: "10px 0px" }}>
                            <div style={{ margin: "10px 15px" }}>
                                <p>{this.getLocalizedText('Understanding')}<br />
                                    <ul>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point1')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point2')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point3')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point4')}
                                                <ul>
                                                    <li>
                                                        <p>
                                                            {this.getLocalizedText('Understanding_Point4_1')}
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>
                                                            {this.getLocalizedText('Understanding_Point4_2')}
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>
                                                            {this.getLocalizedText('Understanding_Point4_3')}
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>
                                                            {this.getLocalizedText('Understanding_Point4_4')}
                                                        </p>
                                                    </li>
                                                </ul>
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point5')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point6')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point7')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point8')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point9')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point10')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point11')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point12')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Understanding_Point13')}
                                            </p>
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{ maxWidth: '950px' }}>
                        <div style={{ border: "1px solid #000000", margin: "10px 0px" }}>
                            <div style={{ margin: "10px 15px" }}>
                                <p><b>{this.getLocalizedText('Psychology_Data_Collection_Header')}</b><br />
                                </p>
                                <p>{this.getLocalizedText('Psychology_Data_Collection_Information')}<br />
                                </p>
                                <p>{this.getLocalizedText('Psychology_Data_Collection_Purpose')}<br />
                                </p>
                                <p>{this.getLocalizedText('Psychology_Data_Protection_Header')}<br />
                                    <ul>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Psychology_Data_Protection_Point1')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Psychology_Data_Protection_Point2')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Psychology_Data_Protection_Point3')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Psychology_Data_Protection_Point4')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Psychology_Data_Protection_Point5')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Psychology_Data_Protection_Point6')}
                                            </p>
                                        </li>
                                    </ul>
                                </p>
                                <p>{this.getLocalizedText('Psychology_Data_Sharing')}<br />
                                </p>
                                <p>{this.getLocalizedText('Psychology_Marketing')}<br />
                                </p>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{ maxWidth: '950px' }}>

                        <div style={{ border: "1px solid #000000", margin: "10px 0px" }}>
                            <div style={{ margin: "10px 15px" }}>
                                <p>{this.getLocalizedText('Psychology_Patient_Rights_Header')}<br />
                                    <ul>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Psychology_Patient_Rights_Point1')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Psychology_Patient_Rights_Point2')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Psychology_Patient_Rights_Point3')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Psychology_Patient_Rights_Point4')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Psychology_Patient_Rights_Point5')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {this.getLocalizedText('Psychology_Patient_Rights_Point6')}
                                            </p>
                                        </li>
                                    </ul>
                                </p>
                                <p><b>{this.getLocalizedText('Psychology_Questions_Concerns')}</b><br />
                                    {this.getLocalizedText('Psychology_Questions_Concerns_Description')}
                                </p>
                                <p><b>{this.getLocalizedText('Psychology_Complaints_Header')}</b><br />
                                    {this.getLocalizedText('Psychology_Complaints_Description')}<br />
                                    {this.getLocalizedText('Psychology_Complaints_DHA')}<br />
                                </p>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{ maxWidth: '950px' }}>

                        <div style={{ border: "1px solid #000000", margin: "10px 0px" }}>
                            <div style={{ margin: "10px 15px" }}>
                                <p><b>{this.getLocalizedText('Psychology_Patient_Responsibility')}</b>
                                </p>
                                <p><b>{this.getLocalizedText('Psychology_Final_Acknowledgment')}</b>
                                </p>
                                <p><b>{this.getLocalizedText('Psychology_Data_Understanding')}</b>
                                </p>
                            </div>
                        </div>

                        <div className={"container"}>
                            <div className={"row"} style={{ marginTop: "10px" }}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Date')}
                                </div>

                                <div className="col-md-3">
                                    {readOnly && form.patientDate ?
                                        moment(new Date(form.patientDate)).format('MMMM DD, YYYY')
                                        :
                                        moment(new Date(this.state.patientDate)).format('MMMM DD, YYYY')
                                    }
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: "15px" }}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Patient_Name')}
                                </div>
                                <div className="col-md-3">
                                    {patientName}
                                </div>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Provider_Name')}
                                </div>
                                <div className="col-md-3">
                                    <TextInput value={this.state.providerName}
                                        disabled={true} style={{ textAlign: "center" }} />
                                </div>
                            </div>

                            <div className={"row"} style={{ marginTop: "10px" }}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Print_Name')}
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                        disabled={!isPatientMinor}
                                        required requiredMessage={this.getLocalizedText('Field_Required')}
                                        validateOn={readOnly ? form.guardianName : this.state.guardianName}>
                                        <TextInput value={readOnly ? form.guardianName : this.state.guardianName}
                                            disabled={readOnly} alphabeticOnly style={{ textAlign: "center" }}
                                            onChange={(val) => this.setState({ guardianName: val })} />
                                    </FormField>
                                </div>
                            </div>
                            <div className={"row"} style={{ marginTop: "10px" }}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Relationship_To_Patient')}
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                        disabled={!isPatientMinor}
                                        required requiredMessage={this.getLocalizedText('Field_Required')}
                                        validateOn={readOnly ? form.guardianName : this.state.guardianName}>
                                        <TextInput
                                            value={readOnly ? form.guardianRelationship : this.state.guardianRelationship}
                                            disabled={readOnly} alphabeticOnly style={{ textAlign: "center" }}
                                            onChange={(val) => this.setState({ guardianRelationship: val })} />
                                    </FormField>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 dim14-form-label">
                                    {this.getLocalizedText('Patient_Signature')}
                                </div>
                                <div className="col-md-6 dim14-form-label">
                                    {this.getLocalizedText('Provider_Signature')}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                        disabled={readOnly}
                                        required requiredMessage={this.getLocalizedText('Signature_Required')}
                                        validateOn={this.state.patientSignature}>
                                        <SignatureInput
                                            signature={readOnly ? form.patientSignature : this.state.patientSignature}
                                            onSave={this.onSavePatientSignature} readOnly={readOnly} />
                                    </FormField>
                                </div>
                                <div className="col-md-6">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                        validateOn={this.state.providerSignature}
                                        required requiredMessage={this.getLocalizedText('Signature_Required')}>
                                        <SignatureDisplay signature={this.state.providerSignature} />
                                    </FormField>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{ width: '1000px' }}>
                        <div className={"row"} style={{ margin: "10px 15px" }}>
                            <div className="col-md-12">
                                <p className="font-weight-bold">
                                    <u>{this.getLocalizedText('Official_Use_Only')}</u></p>
                                <p className="font-weight-bold">
                                    {this.getLocalizedText('Witness_Statement_Header')}</p>
                                <p><i>{this.getLocalizedText('Witness_Statement')}</i></p>
                            </div>
                        </div>

                        <div className="row" style={{ margin: "10px 15px" }}>
                            <div className="col-md-6 dim14-form-label">
                                {this.getLocalizedText('Witness_Name')}
                            </div>
                            <div className="col-md-6 dim14-base-input">
                                <TextInput value={readOnly ? form.witnessName : this.state.witnessName}
                                    disabled={readOnly} alphabeticOnly style={{ textAlign: "center" }}
                                    onChange={(val) => this.setState({ witnessName: val })} />
                            </div>
                            <div className="col-md-6 dim14-form-label">
                                {this.getLocalizedText('Witness_Signature')}
                            </div>
                            <div className="col-md-6">
                                <SignatureInput
                                    signature={readOnly ? form.witnessSignature : this.state.witnessSignature}
                                    onSave={this.onSaveWitnessSignature} readOnly={readOnly} />
                            </div>
                        </div>
                    </div>
                </Wizard.Page>
            </Wizard>
        );
    }
}

export default PsychologyConsentForm;
